import { render, staticRenderFns } from "./FeedCard.vue?vue&type=template&id=029adf0c&scoped=true"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"
import style0 from "./FeedCard.vue?vue&type=style&index=0&id=029adf0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029adf0c",
  null
  
)

export default component.exports